// extracted by mini-css-extract-plugin
export var payCycle = "Price-module--payCycle--2a9d2";
export var price = "Price-module--price--a6048";
export var priceLine = "Price-module--priceLine--7dc42";
export var wrapper = "Price-module--wrapper--65f7b";
export var yearlyMonthlyPrice = "Price-module--yearlyMonthlyPrice--45963";